import { State } from '#/unified-rfqs/ui/rfq-builder/store';
import { getActiveProductsByVenue } from '#/products/domain';
import { venueSupportsCustomStrategy } from '#/unified-rfqs/entities/products/venue';
import { MULTI_PRODUCT_OPTION_VALUE } from '#/unified-rfqs/ui/rfq-builder/multi-product';

const ALL_OPTION = { value: null, label: 'All' };
const MULTI_OPTION = {
  value: MULTI_PRODUCT_OPTION_VALUE,
  label: 'Multi-Product',
};

export default function productView(
  selectedProductCode: State['productCode'],
  selectedVenue: State['venue'],
  auction: State['auction'],
  isMultiProductSelected: boolean,
  allowMultiProduct: boolean,
) {
  const products = getActiveProductsByVenue(selectedVenue, auction);

  const productOptions = products.map((p) => ({
    value: p.code,
    label: p.longName,
  }));

  const options = venueSupportsCustomStrategy(selectedVenue)
    ? [
        ...(allowMultiProduct ? [MULTI_OPTION] : []),
        ...productOptions,
        ALL_OPTION,
      ]
    : productOptions;

  if (isMultiProductSelected) return { options, selectedOption: MULTI_OPTION };

  const selectedOption = options.find(
    (option) => option.value === selectedProductCode,
  );

  if (selectedOption === undefined)
    throw new TypeError(
      `Product with code '${selectedProductCode}' doesn't exist.`,
    );

  return { options, selectedOption };
}
